import {persistReducer, persistStore} from 'redux-persist';

import AsyncStorage from '@react-native-async-storage/async-storage';
import {PersistGate} from 'redux-persist/integration/react';
import {Provider} from 'react-redux';
import React from 'react';

import {configureStore} from '@reduxjs/toolkit';
import rootReducer from './reducers/rootReducer';

const persistConfig = {
  key: 'root',
  version: 1,
  storage: AsyncStorage,
  whitelist: ['app_info', 'firstVisit', 'location', 'user', 'event'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  // only peristicing in the app
  reducer: persistedReducer,
  devTools: __DEV__,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: {
        ignoredPaths: ['local', 'hunts', 'user', 'communityPhotos'],
        warnAfter: 128,
      },
      // serializableCheck: {
      //   ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      //   ignoredPaths: ['local', 'hunts', 'user', 'communityPhotos'],
      //   warnAfter: 128,
      // },
      serializableCheck: false,
    }),
});

let persistor = persistStore(store);

const Store = ({children}) => {
  console.log('loading store');
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {children}
      </PersistGate>
    </Provider>
  );
};

export default Store;
